<div *transloco="let t; read: 'dod-side-content'">
  <accredible-read-more
    styleType="DOD"
    [horizontalStyle]="isTablet()"
    [title]="t('title')"
    [ariaLabel]="t('aria_label')"
    [subtitle]="t('subtitle')"
    [urlLabel]="t('url_label')"
    [url]="
      'https://www.accredible.com/blog/find-verified-professionals-faster-the-new-way-to-source-and-trust-skills'
    " />
</div>
